module.exports = __webpack_public_path__ + "static/giga-khurtsilava-5kwVYW8ZIHo-unsplash-6f60f70759ac5b550768db73bb222080.jpg";